
import { AccessTime, AccountBalance, Add, AddBox, AddCircle, AddCircleOutline, AddCircleOutlineOutlined, Analytics, AnalyticsOutlined, Api, ApiOutlined, ArrowBack, ArrowDownward, ArrowDropDown, ArrowDropUp, ArrowForward, ArrowRight, ArrowUpward, Assignment, AssignmentOutlined, AutoStories, AutoStoriesOutlined, Badge, BadgeOutlined, Block, CalendarMonthOutlined, Cancel, Category, CategoryOutlined, CenterFocusStrongOutlined, Check, CheckBoxOutlineBlank, CheckCircle, ChevronLeft, ChevronRight, Clear, Close, CoPresent, CoPresentOutlined, Comment, CopyAll, CreateNewFolder, Crop169, Crop32, DarkMode, Dashboard, DashboardOutlined, DataObjectRounded, Delete, DeleteForever, DeleteOutlined, Description, DescriptionOutlined, DeveloperMode, DeveloperModeOutlined, DeviceHub, Diversity2Outlined, Dns, DoNotDisturb, Done, Download, DownloadForOffline, DownloadOutlined, Downloading, DragIndicator, DynamicForm, DynamicFormOutlined, Edit, EditOutlined, EmojiPeople, EmojiPeopleOutlined, Error, Feedback, FeedbackOutlined, FiberManualRecord, FiberManualRecordOutlined, Filter, FilterAltOffRounded, FilterAltRounded, Folder, Forward10, Fullscreen, FullscreenExit, GridView, Groups2, Groups2Outlined, Home, HomeOutlined, Info, InsertDriveFile, Insights, InsightsOutlined, Key, KeyboardArrowDown, KeyboardArrowLeft, KeyboardArrowRight, KeyboardArrowUp, KeyboardVoice, Language, LightMode, LinkOutlined, LiveHelp, LiveHelpOutlined, Lock, LockOutlined, ManageAccounts, ManageAccountsOutlined, MenuBook, Monitor, NavigateNext, NewReleases, NotificationsActiveOutlined, OndemandVideo, OndemandVideoOutlined, OpenInNew, Password, Pause, PeopleAlt, Person, PlayArrow, PlayCircleFilledWhite, PlayCircleFilledWhiteOutlined, PortraitOutlined, PortraitRounded, PsychologyAlt, PsychologyAltOutlined, QuestionMark, QuestionMarkOutlined, Quiz, QuizOutlined, RateReview, Remove, RemoveCircle, Replay, Replay10, Reply, Rule, RuleOutlined, School, SchoolOutlined, Search, Segment, Send, Settings, SettingsOutlined, SplitscreenRounded, Stop, Subscriptions, SubscriptionsOutlined, SupervisedUserCircle, SupervisedUserCircleOutlined, TableRows, ThumbDown, ThumbDownOutlined, ThumbUp, ThumbUpOutlined, UploadFile, Videocam, VideocamOutlined, ViewColumnOutlined, ViewList, ViewQuilt, ViewQuiltOutlined, Visibility, VisibilityOff, VolumeDown, VolumeOff, VolumeUp, Warning, Wc, WorkHistory, ZoomIn, ZoomOut } from '@mui/icons-material'

import axios from 'axios'
import dayjs from 'dayjs'
import pngThumb from '../../src/assets/png-logo.svg'
import jpgThumb from '../../src/assets/png-logo.svg'
import tiffThumb from '../../src/assets/png-logo.svg'
import pdfThumb from '../../src/assets/pdf-logo.svg'
import wordThumb from '../../src/assets/word-logo.svg'
import excelThumb from '../../src/assets/excel-logo.svg'
import fileThumb from '../../src/assets/file-logo.svg'
import pptThumb from '../../src/assets/ppt-logo.svg'
import writeXlsxFile from 'write-excel-file'

import defaultOnlineCourseThumb1 from '../../src/assets/default-thumb-1.svg'
import defaultOnlineCourseThumb2 from '../../src/assets/default-thumb-2.svg'
import defaultOnlineCourseThumb3 from '../../src/assets/default-thumb-3.svg'

const defaultIconProps = {
    sx: {
        fontSize: "inherit",
        color: "inherit"
    }
}

export const Icons = {}
Icons.default = {
    CopyAll: <CopyAll  {...defaultIconProps} />,
    Password: <Password  {...defaultIconProps} />,
    Key: <Key  {...defaultIconProps} />,
    SystemTheme: <Monitor  {...defaultIconProps} />,
    LightMode: <LightMode  {...defaultIconProps} />,
    DarkMode: <DarkMode  {...defaultIconProps} />,
    User: <Person  {...defaultIconProps} />,
    Info: <Info  {...defaultIconProps} />,
    Clock: <AccessTime  {...defaultIconProps} />,
    Language: <Language  {...defaultIconProps} />,
    WorkHistory: <WorkHistory  {...defaultIconProps} />,
    ZoomIn: <ZoomIn {...defaultIconProps} />,
    ZoomOut: <ZoomOut {...defaultIconProps} />,
    CenterFocusStrongOutlined: <CenterFocusStrongOutlined {...defaultIconProps} />,
    Replay: <Replay {...defaultIconProps} />,
    Exams: <Quiz {...defaultIconProps} />,
    PsychologyAlt: <PsychologyAlt {...defaultIconProps} />,
    PsychologyAltOutlined: <PsychologyAltOutlined {...defaultIconProps} />,
    TemporaryUsersOutlined: <SupervisedUserCircleOutlined {...defaultIconProps} />,
    TemporaryUsers: <SupervisedUserCircle {...defaultIconProps} />,
    Diversity: <Diversity2Outlined {...defaultIconProps} />,
    Calendar: <CalendarMonthOutlined {...defaultIconProps} />,
    Link: <LinkOutlined {...defaultIconProps} />,
    NotificationsOutlined: <NotificationsActiveOutlined {...defaultIconProps} />,
    ArrowForward: < ArrowForward {...defaultIconProps} />,
    ManageAccounts: <ManageAccounts {...defaultIconProps} />,
    ManageAccountsOutlined: <ManageAccountsOutlined {...defaultIconProps} />,
    Entity: <Category {...defaultIconProps} />,
    EntityOutlined: <CategoryOutlined {...defaultIconProps} />,
    Templates: <ViewQuilt {...defaultIconProps} />,
    TemplatesOutlined: <ViewQuiltOutlined {...defaultIconProps} />,
    Form: <DynamicForm {...defaultIconProps} />,
    FormOutlined: <DynamicFormOutlined {...defaultIconProps} />,
    Api: <Api {...defaultIconProps} />,
    ApiOutlined: <ApiOutlined {...defaultIconProps} />,
    Auditor: <SupervisedUserCircle {...defaultIconProps} />,
    AuditorOutlined: <SupervisedUserCircleOutlined {...defaultIconProps} />,
    Rule: <Rule {...defaultIconProps} />,
    RuleOutlined: <RuleOutlined {...defaultIconProps} />,
    KeyBoardArrowRight: <KeyboardArrowRight {...defaultIconProps} />,
    KeyBoardArrowLeft: <KeyboardArrowLeft {...defaultIconProps} />,
    ArrowRight: <ArrowRight {...defaultIconProps} />,
    Dashboard: <Dashboard {...defaultIconProps} />,
    DashboardOutlined: <DashboardOutlined {...defaultIconProps} />,
    Subjects: <AutoStories {...defaultIconProps} />,
    SubjectsOutlined: <AutoStoriesOutlined {...defaultIconProps} />,
    Course: <CoPresent {...defaultIconProps} />,
    CourseOutlined: <CoPresentOutlined {...defaultIconProps} />,
    Subscriptions: <Subscriptions {...defaultIconProps} />,
    SubscriptionsOutlined: <SubscriptionsOutlined {...defaultIconProps} />,
    Badge: <Badge {...defaultIconProps} />,
    BadgeOutlined: <BadgeOutlined {...defaultIconProps} />,
    QuestionMark: <QuestionMark {...defaultIconProps} />,
    QuestionMarkOutlined: <QuestionMarkOutlined {...defaultIconProps} />,
    Groups2: <Groups2 {...defaultIconProps} />,
    Groups2Outlined: <Groups2Outlined {...defaultIconProps} />,
    Category: <CategoryOutlined {...defaultIconProps} />,
    Reply: <Reply {...defaultIconProps} />,
    Like: <ThumbUp {...defaultIconProps} />,
    LikeOutlined: <ThumbUpOutlined {...defaultIconProps} />,
    Unlike: <ThumbDown {...defaultIconProps} />,
    UnlikeOutlined: <ThumbDownOutlined {...defaultIconProps} />,
    DropDown: <ArrowDropDown {...defaultIconProps} />,
    DropUp: <ArrowDropUp {...defaultIconProps} />,
    Send: <Send {...defaultIconProps} />,
    Comment: <Comment {...defaultIconProps} />,
    FilterAlt: <FilterAltRounded {...defaultIconProps} />,
    FilterAltOff: <FilterAltOffRounded {...defaultIconProps} />,
    Warning: <Warning {...defaultIconProps} />,
    Filter: <Filter {...defaultIconProps} />,
    DoNotDisturb: <DoNotDisturb {...defaultIconProps} />,
    School: <School {...defaultIconProps} />,
    SchoolOutlined: <SchoolOutlined {...defaultIconProps} />,
    Stop: <Stop {...defaultIconProps} />,
    AudioRecorder: <KeyboardVoice {...defaultIconProps} />,
    ArrowBack: <ArrowBack {...defaultIconProps} />,
    Checkbox: <CheckBoxOutlineBlank {...defaultIconProps} />,
    Rows: <TableRows {...defaultIconProps} />,
    AddBox: <AddBox {...defaultIconProps} />,
    Settings: <Settings {...defaultIconProps} />,
    SettingsOutlined: <SettingsOutlined {...defaultIconProps} />,
    ArrowDownward: <ArrowDownward {...defaultIconProps} />,
    ArrowUpward: <ArrowUpward {...defaultIconProps} />,
    KeyboardArrowUp: <KeyboardArrowUp {...defaultIconProps} />,
    ViewColumnRounded: <ViewColumnOutlined {...defaultIconProps} />,
    AddCircleOutlined: <AddCircleOutline {...defaultIconProps} />,
    AddCircleIcon: <AddCircle {...defaultIconProps} />,
    AddCircleOutlinedIcon: <AddCircleOutlineOutlined {...defaultIconProps} />,
    DragIndicatorIcon: <DragIndicator {...defaultIconProps} />,
    JSONBrackets: <DataObjectRounded {...defaultIconProps} />,
    SplitScreen: <SplitscreenRounded {...defaultIconProps} />,
    Protrait: <PortraitRounded {...defaultIconProps} />,
    ProtraitOutlined: <PortraitOutlined {...defaultIconProps} />,
    KeyboardArrowDownIcon: <KeyboardArrowDown {...defaultIconProps} />,
    Crop32Icon: <Crop32 {...defaultIconProps} />,
    Crop169Icon: <Crop169 {...defaultIconProps} />,
    FullscreenIcon: <Fullscreen {...defaultIconProps} />,
    FullscreenExitIcon: <FullscreenExit {...defaultIconProps} />,
    VolumeOffIcon: <VolumeOff {...defaultIconProps} />,
    VolumeDownIcon: <VolumeDown {...defaultIconProps} />,
    VolumeUpIcon: <VolumeUp {...defaultIconProps} />,
    PlayArrowIcon: <PlayArrow {...defaultIconProps} />,
    PauseIcon: <Pause {...defaultIconProps} />,
    Forward10Icon: <Forward10 {...defaultIconProps} />,
    Replay10Icon: <Replay10 {...defaultIconProps} />,
    InsightsIcon: <Insights {...defaultIconProps} />,
    InsightsIconOutlined: <InsightsOutlined {...defaultIconProps} />,
    GridViewIcon: <GridView {...defaultIconProps} />,
    SegmentView: <Segment {...defaultIconProps} />,
    ViewListIcon: <ViewList {...defaultIconProps} />,
    LiveHelpIcon: <LiveHelp {...defaultIconProps} />,
    LiveHelpIconOutlined: <LiveHelpOutlined {...defaultIconProps} />,
    CreateNewFolderIcon: <CreateNewFolder {...defaultIconProps} />,
    InsertDriveFileIcon: <InsertDriveFile {...defaultIconProps} />,
    RemoveIcon: <Remove {...defaultIconProps} />,
    DownloadingIcon: <Downloading {...defaultIconProps} />,
    FolderIcon: <Folder {...defaultIconProps} />,
    CheckIcon: <Check {...defaultIconProps} />,
    QuizIcon: <PsychologyAlt {...defaultIconProps} />,
    QuizIconOutlined: <QuizOutlined {...defaultIconProps} />,
    NavigateNextIcon: <NavigateNext {...defaultIconProps} />,
    RemoveCircleIcon: <RemoveCircle {...defaultIconProps} />,
    NewReleasesIcon: <NewReleases {...defaultIconProps} />,
    PlayCircleFilledWhiteIcon: <PlayCircleFilledWhite {...defaultIconProps} />,
    PlayCircleFilledWhiteIconOutlined: <PlayCircleFilledWhiteOutlined {...defaultIconProps} />,
    FiberManualRecordIcon: <FiberManualRecord {...defaultIconProps} />,
    FiberManualRecordIconOutlined: <FiberManualRecordOutlined {...defaultIconProps} />,
    UploadFileIcon: <UploadFile {...defaultIconProps} />,
    EmojiPeopleIcon: <EmojiPeople {...defaultIconProps} />,
    EmojiPeopleIconOutlined: <EmojiPeopleOutlined {...defaultIconProps} />,
    ErrorIcon: <Error {...defaultIconProps} />,
    ClearIcon: <Clear {...defaultIconProps} />,
    BlockIcon: <Block {...defaultIconProps} />,
    CheckCircleIcon: <CheckCircle {...defaultIconProps} />,
    DoneIcon: <Done {...defaultIconProps} />,
    EditIcon: <Edit {...defaultIconProps} />,
    EditIconOutlined: <EditOutlined {...defaultIconProps} />,
    AccountBalanceIcon: <AccountBalance {...defaultIconProps} />,
    MenuBookIcon: <MenuBook {...defaultIconProps} />,
    AssignmentIcon: <Assignment {...defaultIconProps} />,
    AssignmentIconOutlined: <AssignmentOutlined {...defaultIconProps} />,
    DescriptionIcon: <Description {...defaultIconProps} />,
    DescriptionIconOutlined: <DescriptionOutlined {...defaultIconProps} />,
    DeviceHubIcon: <DeviceHub {...defaultIconProps} />,
    PeopleAltIcon: <PeopleAlt {...defaultIconProps} />,
    WcIcon: <Wc {...defaultIconProps} />,
    SearchIcon: <Search {...defaultIconProps} />,
    AddIcon: <Add {...defaultIconProps} />,
    RateReviewIcon: <RateReview {...defaultIconProps} />,
    DeleteIcon: <Delete {...defaultIconProps} />,
    DeleteIconOutlined: <DeleteOutlined {...defaultIconProps} />,
    VisibilityIcon: <Visibility {...defaultIconProps} />,
    VisibilityOffIcon: <VisibilityOff {...defaultIconProps} />,
    OndemandVideoIcon: <OndemandVideo {...defaultIconProps} />,
    OndemandVideoIconOutlined: <OndemandVideoOutlined {...defaultIconProps} />,
    FeedbackIcon: <Feedback {...defaultIconProps} />,
    FeedbackIconOutlined: <FeedbackOutlined {...defaultIconProps} />,
    HomeIcon: <Home {...defaultIconProps} />,
    HomeIconOutlined: <HomeOutlined {...defaultIconProps} />,
    DeveloperModeIcon: <DeveloperMode {...defaultIconProps} />,
    DeveloperModeIconOutlined: <DeveloperModeOutlined {...defaultIconProps} />,
    LockIcon: <Lock {...defaultIconProps} />,
    LockIconOutlined: <LockOutlined {...defaultIconProps} />,
    DnsIcon: <Dns {...defaultIconProps} />,
    AnalyticsIcon: <Analytics {...defaultIconProps} />,
    AnalyticsIconOutlined: <AnalyticsOutlined {...defaultIconProps} />,
    CloseIcon: <Close {...defaultIconProps} />,
    VideocamIcon: <Videocam {...defaultIconProps} />,
    VideocamIconOutlined: <VideocamOutlined {...defaultIconProps} />,
    ChevronLeftIcon: <ChevronLeft {...defaultIconProps} />,
    ChevronRightIcon: <ChevronRight {...defaultIconProps} />,
    CancelIcon: <Cancel {...defaultIconProps} />,
    DownloadForOfflineIcon: <DownloadForOffline {...defaultIconProps} />,
    DownloadIcon: <Download {...defaultIconProps} />,
    DownloadIconOutlined: <DownloadOutlined {...defaultIconProps} />,
    OpenInNewIcon: <OpenInNew {...defaultIconProps} />,
    DeleteForever: <DeleteForever  {...defaultIconProps} />
}

Icons.small = {
    ZoomIn: <ZoomIn fontSize='small' {...defaultIconProps} />,
    ZoomOut: <ZoomOut fontSize='small' {...defaultIconProps} />,
    CenterFocusStrongOutlined: <CenterFocusStrongOutlined fontSize='small' {...defaultIconProps} />,
    VisibilityIcon: <Visibility fontSize="small" {...defaultIconProps} />,
    OpenInNewIcon: <OpenInNew fontSize="small" {...defaultIconProps} />,
    CloseIcon: <Close fontSize='small' {...defaultIconProps} />,
    KeyboardArrowDown: <KeyboardArrowDown fontSize='small' {...defaultIconProps} />,
    Category: <CategoryOutlined fontSize='small' {...defaultIconProps} />,
    DropDown: <ArrowDropDown fontSize="small" {...defaultIconProps} />,
    ChevronLeftIcon: <ChevronLeft fontSize='small' {...defaultIconProps} />,
    ChevronRightIcon: <ChevronRight fontSize='small' {...defaultIconProps} />,
    VolumeOffIcon: <VolumeOff fontSize="small" {...defaultIconProps} />,
    VolumeDownIcon: <VolumeDown fontSize="small" {...defaultIconProps} />,
    VolumeUpIcon: <VolumeUp fontSize="small" {...defaultIconProps} />,
    DownloadIcon: <DownloadOutlined fontSize='small' {...defaultIconProps} />,
    DeleteIcon: <DeleteOutlined fontSize='small' {...defaultIconProps} />,
    EditIcon: <Edit fontSize='small'  {...defaultIconProps} />
}

export const erpAdmissionExamRegisterLink = 'https://acharya.ac.uz/'
export const erpResultsPageLink = `https://www.acharya.uz/admission/auet-results1.php`


export const FLAT_LIGHT_COLORS = ['#DBFFD4', '#D5F0FF', '#FFE0E4', '#b2dfdb', '#e6ee9c', '#c5e1a5', '#a5d6a7', '#ffcc80', '#ffe082', '#ffccbc']
export const FLAT_COLORS = ["#2e3131", "#392e4a", "#16453e", "#4A89DC", "#37BC9B"]
export const chipColors = ['#49982E', '#FF9053', '#353297', '#00ABE4', '#5E2974']
export const attachmentsSupportedFormats = ['.png', '.jpg', '.ppt', '.jpeg', '.pdf', '.docx', '.xls', '.xlsx', '.mov', '.mp4', '.wmv', '.webm', '.avi', '.mkv', '.gif', '.webp', '.tiff', '.mp3', '.wav', '.txt']
export const studyMaterialFormats = ['.pdf', '.docx', '.ppsx', '.pptx', '.odp']
export const attachmentThumbnails = {
    'png': pngThumb,
    'jpg': jpgThumb,
    'jpeg': jpgThumb,
    'tiff': tiffThumb,
    'pdf': pdfThumb,
    'docx': wordThumb,
    'xls': excelThumb,
    'xlsx': excelThumb,
    'default': fileThumb,
    'pptx': pptThumb,
    'ppsx': pptThumb,
}

export const FLAT_COLORS_WITH_BACKGROUND = [
    { bg: '#DAFFD4', color: '#1FC439' },
    { bg: '#FFD9CB', color: '#E25A26' },
    { bg: '#FFEBFF', color: '#5E2974' },
    { bg: '#FFDAFE', color: '#A200E5' },
    { bg: '#FFE3E2', color: '#FF3E39' },
    { bg: '#CCE1EF', color: '#139CFF' },
    { bg: '#FED7FD', color: '#C54097' },
    { bg: '#FFDBCD', color: '#FF7641' },
]

export const defaultOnlineCourseThumbs = [
    defaultOnlineCourseThumb1,
    defaultOnlineCourseThumb2,
    defaultOnlineCourseThumb3
]

export const Axios = axios.create( {
    baseURL: 'http://localhost:5500/api/',
    headers: {
        "Authorization": `Bearer ${localStorage.getItem( "aliveMaterialAPIAK" )}`
    }
} )

export const days = ['Monday', 'Tuesday', 'Wednesday', 'Thrusday', 'Friday', 'Saturday', 'Sunday']
export const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
export const hours = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"]
export const eventCells = ["00:00:00", "00:30:00", "01:00:00", "01:30:00", "02:00:00", "02:30:00", "03:00:00", "03:30:00", "04:00:00", "04:30:00", "05:00:00", "05:30:00", "06:00:00", "06:30:00", "07:00:00", "07:30:00", "08:00:00", "08:30:00", "09:00:00", "09:30:00", "10:00:00", "10:30:00", "11:00:00", "11:30:00", "12:00:00", "12:30:00", "13:00:00", "13:30:00", "14:00:00", "14:30:00", "15:00:00", "15:30:00", "16:00:00", "16:30:00", "17:00:00", "17:30:00", "18:00:00", "18:30:00", "19:00:00", "19:30:00", "20:00:00", "20:30:00", "21:00:00", "21:30:00", "22:00:00", "22:30:00", "23:00:00", "23:30:00"]
export const supportedFormats = ["image/png", "image/jpg", "image/jpeg"]
export const erpDashboardLink = "https://acharyaerp.uz/Dashboard"
export const erpApiBaseUrl = "https://acharyajava.uz/AcharyaInstituteUZB"


export const latexDelimiters = [
    { left: '$$', right: '$$', display: true },
    { left: '\\(', right: '\\)', display: false },
    { left: '$', right: '$', display: false },
    { left: '\\[', right: '\\]', display: true },
]

export const AUDIT_COUNT_CARD_COLORS = [
    { bg: '#0DCAF04D', circleColor: '#0DCAF0' },
    { bg: '#DC35454D', circleColor: '#DC3545' },
    { bg: '#1987544D', circleColor: '#198754' },
    { bg: '#0D6EFD4D', circleColor: '#0D6EFD' },
    { bg: '#FFC1584D', circleColor: '#FFC158' },
]

/**
 * Checks if a File/Blob is valid UTF-8
 * @param {File} file - The file from the input element
 * @returns {Promise<boolean>}
 */
export const isFileUTF8 = async ( file ) => {
    try {
        const buffer = await file.arrayBuffer()
        const decoder = new TextDecoder( 'utf-8', { fatal: true } )
        decoder.decode( buffer )
        return true
    } catch ( err ) {
        console.error( "Encoding mismatch detected:", err )
        return false
    }
}

export const convertToCDNLink = ( data ) => {
    return data.replace( /digitaloceanspaces/, 'cdn.digitaloceanspaces' )
}

export const sortArrayOfObjectsByKey = ( list, key, order = 1, dataType = "string" ) => {
    if ( dataType === "string" ) {
        const sortedList = [...list]
        sortedList.sort( ( a, b ) => a[key].localeCompare( b[key] ) )
        if ( order === -1 ) sortedList.reverse()
        return sortedList
    } else {
        const sortedList = [...list]
        sortedList.sort( ( a, b ) => a[key] > b[key] ? 1 : -1 )
        if ( order === -1 ) sortedList.reverse()
        return sortedList
    }
}

export const getCurrentWeek = ( date = new Date() ) => {
    const curr = new Date( date )
    const dday = curr.getDay()
    let week = []
    if ( dday === 0 ) {
        for ( let i = 5; i >= -1; i-- ) {
            let tempCurr = new Date( date )
            let first = tempCurr.getDate() - i
            let day = new Date( tempCurr.setDate( first ) ).toISOString().slice( 0, 10 )
            week.push( day )
        }
    }
    else if ( dday !== 0 ) {
        for ( let i = 1; i <= 6; i++ ) {
            let first = curr.getDate() - curr.getDay() + i + 1
            let day = new Date( curr.setDate( first ) ).toISOString().slice( 0, 10 )
            week.push( day )
        }
        week.push( new Date( curr.setDate( curr.getDate() + 1 ) ).toISOString().slice( 0, 10 ) )
    }

    return week
}


let debounceTimeoutIds = {}
export const debounce = ( debounceId, func, delay = 500 ) => {
    return ( ...args ) => {
        if ( debounceTimeoutIds[debounceId] ) clearTimeout( debounceTimeoutIds[debounceId] )
        debounceTimeoutIds[debounceId] = setTimeout( () => {
            func.apply( null, args )
        }, delay )
    }
}

export const getCountString = ( count ) => {
    if ( Number.isNaN( +count ) ) return '_'
    if ( count < 1000 ) return count
    const inKilo = count / 1000
    if ( +inKilo < 1000 ) {
        const [whole, decimal = '0'] = ( '' + inKilo ).split( '.' )
        return `${whole}.${decimal[0]}K+`
    }
    const inMil = ( +inKilo / 1000 ).toFixed( 1 )
    const [whole, decimal = '0'] = ( '' + inMil ).split( '.' )
    return `${whole}.${decimal[0]}M+`
}


export const getPreviousWeek = ( currentWeekStartDate ) => {
    const currentWeekDate = new Date( currentWeekStartDate[0] )
    console.log( currentWeekStartDate )
    const newWeekDate = new Date( currentWeekDate.setDate( currentWeekDate.getDate() - 7 ) )
    const formatedDate = newWeekDate.toLocaleDateString( 'en-us', { year: "numeric", month: "numeric", day: "numeric" } ).replace( /\//g, '-' )
    console.log( getCurrentWeek( formatedDate ) )
    return getCurrentWeek( formatedDate )
}

export const getPreviousWorkWeek = ( currentWeekStartDate ) => {
    const currentWeekDate = new Date( currentWeekStartDate[0] )
    const newWeekDate = new Date( currentWeekDate.setDate( currentWeekDate.getDate() - 7 ) )
    const formatedDate = newWeekDate.toLocaleDateString( 'en-us', { year: "numeric", month: "numeric", day: "numeric" } ).replace( /\//g, '-' )
    return getCurrentWorkWeek( formatedDate )
}

export const isMobileDevice = () => {
    const userAgent = navigator.userAgent.toLowerCase()
    const isMobileUA = /mobile|android|iphone|ipad|phone/i.test( userAgent )
    const isSmallScreen = window.matchMedia( '(max-width: 767px)' ).matches
    return { isMobile: isMobileUA || typeof window?.orientation !== 'undefined' || navigator.userAgent.indexOf( 'IEMobile' ) !== -1, isSmallScreen }
}

export const getNextWeek = ( currentWeekStartDate ) => {
    const currentWeekDate = new Date( currentWeekStartDate[0] )
    const newWeekDate = new Date( currentWeekDate.setDate( currentWeekDate.getDate() + 7 ) )
    const formatedDate = newWeekDate.toLocaleDateString( 'en-us', { year: "numeric", month: "numeric", day: "numeric" } ).replace( /\//g, '-' )
    return getCurrentWeek( formatedDate )
}

export const getNextWorkWeek = ( currentWeekStartDate ) => {
    const currentWeekDate = new Date( currentWeekStartDate[0] )
    const newWeekDate = new Date( currentWeekDate.setDate( currentWeekDate.getDate() + 7 ) )
    const formatedDate = newWeekDate.toLocaleDateString( 'en-us', { year: "numeric", month: "numeric", day: "numeric" } ).replace( /\//g, '-' )
    return getCurrentWorkWeek( formatedDate )
}

export const getCurrentWorkWeek = ( date = new Date() ) => {
    const curr = new Date( date )
    const dday = curr.getDay()
    let week = []
    if ( dday === 0 ) {
        for ( let i = 5; i >= -1; i-- ) {
            let tempCurr = new Date( date )
            let first = tempCurr.getDate() - i
            let day = new Date( tempCurr.setDate( first ) ).toISOString().slice( 0, 10 )
            week.push( day )
        }
    }
    else if ( dday !== 0 ) {
        for ( let i = 1; i <= 6; i++ ) {
            let first = curr.getDate() - curr.getDay() + i + 1
            let day = new Date( curr.setDate( first ) ).toISOString().slice( 0, 10 )
            week.push( day )
        }
    }
    return week.slice( 0, 5 )
}

export const getCurrentDate = ( date = new Date() ) => {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thrusday', 'Friday', 'Saturday']
    const today = new Date( date )
    const formatedDate = today.toLocaleDateString( 'en-us', { year: "numeric", month: "numeric", day: "numeric" } )
    return [formatedDate.replace( /\//g, '-' ), today.getDate(), days[today.getDay()], months[today.getMonth()], today.getFullYear(), today.toISOString().slice( 0, 10 )]
}

export const getPreviousDate = ( currentDate ) => {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thrusday', 'Friday', 'Saturday']
    const current = new Date( currentDate )
    const previousDate = new Date( current.setDate( current.getDate() - 1 ) )
    const formatedDate = previousDate.toLocaleDateString( 'en-us', { year: "numeric", month: "numeric", day: "numeric" } ).replace( /\//g, '-' )
    return [formatedDate, previousDate.getDate(), days[previousDate.getDay()]]
}

export const getNextDate = ( currentDate ) => {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thrusday', 'Friday', 'Saturday']
    const current = new Date( currentDate )
    const nextDate = new Date( current.setDate( current.getDate() + 1 ) )
    const formatedDate = nextDate.toLocaleDateString( 'en-us', { year: "numeric", month: "numeric", day: "numeric" } ).replace( /\//g, '-' )
    return [formatedDate, nextDate.getDate(), days[nextDate.getDay()]]
}

export const jsDateFormat = ( date ) => {
    let d = date.split( "T" )[0]
    d = new Date( d ).setDate( new Date( d ).getDate() + 1 )
    return ( new Date( d ).toISOString() ).split( "T" )[0]
}

export const normalDateFormat = ( date ) => {
    let d = date.split( "T" )[0]
    d = new Date( d ).setDate( new Date( d ).getDate() + 1 )
    console.log( "FDAA", ( new Date( d ).toLocaleDateString( "en-GB", { year: "numeric", day: "2-digit", month: "2-digit" } ) ).replace( /\//g, '-' ) )
    return ( new Date( d ).toLocaleDateString( "en-GB", { year: "numeric", day: "2-digit", month: "2-digit" } ) ).replace( /\//g, '-' )
}

export const shuffleArray = ( array ) => {
    let currentIndex = array.length, randomIndex

    // While there remain elements to shuffle.
    while ( currentIndex !== 0 ) {

        // Pick a remaining element.
        randomIndex = Math.floor( Math.random() * currentIndex )
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]]
    }

    return array
}

export const mergeArray = ( indexes, arrayList ) => {
    let newArray = []
    for ( let i = 0; i < indexes.length; i++ ) {
        const index = indexes[i]
        newArray = newArray.concat( arrayList[index] )
    }
    return newArray
}

export const exportAssignmentReport = async ( assignments ) => {
    const head = [{ fontWeight: 'bold', value: "Sl.No." }, { fontWeight: 'bold', value: "AUID" }, { fontWeight: 'bold', value: "Student Name" }, { fontWeight: 'bold', value: "Submitted On" }, { fontWeight: 'bold', value: "Score" }]
    let data = []
    data.push( head )
    assignments.forEach( ( item, i ) => {
        let row = []
        row.push( { value: i + 1, type: Number } )
        row.push( { value: item.assignment_submitted_by, type: String } )
        row.push( { value: item.student_name, type: String } )
        row.push( { value: item.assignment_submitted_on, type: String } )
        row.push( { value: item.assignment_marks, type: String } )
        data.push( row )
    } )
    const excelFile = await writeXlsxFile( data, { buffer: true } )
    const blob = new Blob( [excelFile] )
    const a = document.createElement( 'a' )
    a.download = `assignment-${assignments[0].assignment_id}-report.xlsx`
    a.href = window.URL.createObjectURL( blob )
    a.click()
}

export const exportStudyMaterialsReport = async ( stats, map, institute ) => {
    try {
        const head = [{ fontWeight: 'bold', value: "Sl.No." }, { fontWeight: 'bold', value: "Faculty Name" }, { fontWeight: 'bold', value: "Faculty ID" }, { fontWeight: 'bold', value: "Institute Department" }, { fontWeight: 'bold', value: "Study Materials" }, { fontWeight: 'bold', value: "Documents" }, { fontWeight: 'bold', value: "Downloads" }]
        let data = []
        data.push( head )
        stats.forEach( ( item, i ) => {
            let row = []
            row.push( { value: i + 1, type: Number } )
            row.push( { value: item.study_material_created_by, type: String } )
            row.push( { value: item.empcode, type: String } )
            row.push( { value: `${institute}-${map[item.empcode]}`, type: String } )
            row.push( { value: item.material_count, type: String } )
            row.push( { value: item.attachment_count, type: String } )
            row.push( { value: item.sum, type: String } )
            data.push( row )
        } )
        const excelFile = await writeXlsxFile( data, { buffer: true } )
        const blob = new Blob( [excelFile] )
        const a = document.createElement( 'a' )
        a.download = `studyMaterial-${institute}-report.xlsx`
        a.href = window.URL.createObjectURL( blob )
        a.click()
        return true
    } catch ( err ) {
        return false
    }
}

export const exportAttendanceReport = async ( attendanceData, fromDate, toDate ) => {
    try {
        const head = [{ fontWeight: 'bold', value: "Date" }, { fontWeight: 'bold', value: "Subject" }, { fontWeight: 'bold', value: "Institute" }, { fontWeight: 'bold', value: "Branch" }, { fontWeight: 'bold', value: "Presenter" }, { fontWeight: 'bold', value: "Duration" }, { fontWeight: 'bold', value: "Attendance Count" }, { fontWeight: 'bold', value: "Student Attendance" }]
        let data = []
        data.push( head )
        attendanceData.forEach( ( item, i ) => {
            let row = []
            row.push( { value: item.selected_date, type: String } )
            row.push( { value: item.subject_name_short, type: String } )
            row.push( { value: item.institute, type: String } )
            row.push( { value: item.branch_name, type: String } )
            row.push( { value: item.presenter, type: String } )
            row.push( { value: item.duration, type: String } )
            row.push( { value: item.attendance, type: Number } )
            row.push( { value: JSON.stringify( item.student_attendance ), type: String } )
            data.push( row )
        } )
        const excelFile = await writeXlsxFile( data, { buffer: true } )
        const blob = new Blob( [excelFile] )
        const a = document.createElement( 'a' )
        a.download = `attendance-report(${fromDate}-${toDate}).xlsx`
        a.href = window.URL.createObjectURL( blob )
        a.click()
        return true
    } catch ( err ) {
        return false
    }
}

export const leadingZeroFormatter = new Intl.NumberFormat( undefined, {
    minimumIntegerDigits: 2,
} )
export const formatVideoDuration = ( time ) => {
    const seconds = Math.floor( time % 60 )
    const minutes = Math.floor( time / 60 ) % 60
    const hours = Math.floor( time / 3600 )
    if ( hours === 0 ) {
        return `${minutes}:${leadingZeroFormatter.format( seconds )}`
    } else {
        return `${hours}:${leadingZeroFormatter.format(
            minutes
        )}:${leadingZeroFormatter.format( seconds )}`
    }
}
export const quillDefaultModule = {
    toolbar: {
        container: [['bold', 'italic', 'underline', 'strike', 'blockquote'], [{ size: ['normal', 'small', 'large'] }], [{ align: [] }], [{ script: 'sub' }, { script: 'super' }], [{ list: 'ordered' }, { list: 'bullet' }], ['link', 'image'], ['clean'], ['code-block']],
    },
}
export const extractMimeType = ( base64String ) => {
    const regex = /^data:(image|video|audio|application|text|font)\/([a-zA-Z0-9-+.]+);base64,/
    const match = base64String.match( regex )

    if ( match ) {
        return match[0]?.split( ':' )[1]?.split( ';' )[0]
    } else {
        console.error( 'Invalid base64 data URL' )
        return null
    }
}

export const extractSpacesLinkFromText = ( data ) => {
    if ( typeof data === 'string' ) {
        const regex = /https:\/\/(?<bucket>[a-z-]+)\.(?<region>[a-zA-Z0-9]+)\.(cdn\.)?digitaloceanspaces\.com\/(?<key>[a-zA-Z_/-]+\/[.a-zA-Z0-9@%()_-\s]+\.\w+\/?)/gm
        const result = Array.from( data.matchAll( regex ) )
        const matched = result.map( ( r ) => r[0] )
        return { matched, matchedWithGroups: result }
    } else return data
}

export const getUniqueStringFromLongString = ( input ) => {
    input = input + ''
    let hash = 0
    for ( let i = 0; i < input.length; i++ ) {
        hash = ( hash << 5 ) - hash + input.charCodeAt( i )
        hash &= hash // Convert to 32-bit integer
    }
    return Math.abs( hash ).toString( 36 ) // Convert to base-36 for compactness
}

export const base64ToFileAndBlob = async ( base64String, fileName, mimeType ) => {
    const byteCharacters = atob( base64String.split( ',' )[1] )

    const byteArray = new Uint8Array( byteCharacters.length )

    for ( let i = 0; i < byteCharacters.length; i++ ) {
        byteArray[i] = byteCharacters.charCodeAt( i )
    }

    const blob = new Blob( [byteArray], { type: mimeType } )

    const file = new File( [blob], fileName, { type: mimeType } )

    return { file, blob }
}

export const secondsToHMS = ( time, showZeroValues = true ) => {
    time = Number( time )
    var h = Math.floor( time / 3600 )
    var m = Math.floor( ( time % 3600 ) / 60 )
    var s = Math.floor( ( time % 3600 ) % 60 )

    if ( showZeroValues )
        return `${leadingZeroFormatter.format( h )}:${leadingZeroFormatter.format( m )}:${leadingZeroFormatter.format( s )}`
    return `${h > 0 ? `${leadingZeroFormatter.format( h )}:` : ""}${leadingZeroFormatter.format( m )}:${leadingZeroFormatter.format( s )}`
}

export const sortByProperty = ( data, setData, property, type, order ) => {
    let newFilteredData = [...data]

    const getNestedProperty = ( obj, keys ) => {
        return keys.reduce( ( acc, key ) => acc && acc[key], obj )
    }

    const keys = property?.split( '.' )
    newFilteredData.sort( ( a, b ) => {
        const aval = getNestedProperty( a, keys )
        const bval = getNestedProperty( b, keys )

        if ( type === 'number' ) {
            if ( order === '1' ) {
                return parseInt( aval ) - parseInt( bval )
            } else {
                return parseInt( bval ) - parseInt( aval )
            }
        } else {
            if ( order === '1' ) {
                return aval?.localeCompare( bval, undefined, { sensitivity: 'base' } )
            } else {
                return bval?.localeCompare( aval, undefined, { sensitivity: 'base' } )
            }
        }
    } )
    setData( newFilteredData )
}

export const showDateInIndianDateFormat = ( datetime = new Date(), options = {} ) => {
    return new Date( datetime ).toLocaleDateString( 'en-IN', { day: "2-digit", month: "2-digit", year: "numeric", ...options } ).replace( /\//g, "-" )
}

export const extractAssignmentFileDetailsFromMinioLocationOrKey = ( locString ) => {
    if ( typeof locString === 'string' && locString.startsWith( "http" ) ) {
        const regex = /http(s)?:\/\/(?<domainAndPort>[\d\w.:]+)\/(?<bucket>[\w]+)\/(?<key>[a-zA-Z_/-]+\/(?<fullFileName>(?<fileName>[.a-zA-Z0-9@%()_-\s]+)\.(?<fileExtension>\w+))\/?)/
        const result = locString.match( regex )

        const matched = result[0]
        return { matched, matchedWithGroups: result, groups: result.groups }
    } else return locString
}

export const boundaryValue = ( min, desired, max ) => {
    if ( desired == null ) {
        return min
    }
    return Math.max( min, Math.min( desired, max ) )
}

export const isIOS = () => {
    return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes( window.navigator?.userAgentData?.platform ) || ( navigator.userAgent.includes( 'Mac' ) && 'ontouchend' in document )
}

export const formatDate = ( datetime, formatOptions = {}, adjustValue = { minutes: 0, hours: 0, seconds: 0 } ) => {
    if ( datetime ) {
        datetime = dayjs( datetime )
        if ( typeof adjustValue !== 'object' ) datetime = datetime.add( +( adjustValue || 0 ), 'minutes' )
        else
            datetime = datetime
                .add( adjustValue.hours || 0, 'hours' )
                .add( adjustValue.minutes || 0, 'minutes' )
                .add( adjustValue.seconds || 0, 'seconds' )
        if ( formatOptions.showTime ) {
            let timeString = datetime.format( 'h:mm a' )
            datetime = datetime.toString()
            return new Date( datetime ).toLocaleDateString( formatOptions.regionCode || 'en-IN', { day: '2-digit', month: '2-digit', year: 'numeric', ...formatOptions } ).replace( /\//g, formatOptions.separator || '-' ) + ` ${timeString}`
        } else if ( formatOptions.format ) {
            return datetime.format( formatOptions.format )
        } else {
            datetime = datetime.toString()
            return new Date( datetime ).toLocaleDateString( formatOptions.regionCode || 'en-IN', { day: '2-digit', month: '2-digit', year: 'numeric', ...formatOptions } ).replace( /\//g, formatOptions.separator || '-' )
        }
    }
    return ''
}

export const getFileSizeFromBytes = ( bytes ) => {
    if ( isNaN( bytes ) ) return '-'
    const kb = bytes / 1024
    if ( kb < 1024 ) return `${kb?.toFixed( 2 )} KB`
    else if ( kb / 1024 < 1024 ) return `${( kb / 1024 )?.toFixed( 2 )} MB`
    else return `${( kb / ( 1024 * 1024 ) )?.toFixed( 2 )} GB`
}

export const time24to12 = ( time ) => {
    try {
        if ( time ) {
            console.log( time )
            const formatedTime = dayjs( new Date( `2024-01-01 ${time}` ) ).format( "hh:mm a" )
            console.log( formatedTime )

            if ( formatedTime !== 'Invalid Date' )
                return formatedTime.toUpperCase()
            else return ''
        }
        else return ""
    } catch ( err ) {
        console.log( "ERROR", err )
        return time
    }
}